import React, { ReactNode, useContext, useEffect, useState } from 'react';

import SoftwarePatchContext from '@totem/components/devices/software-patches/softwarePatchContext';
import { SoftwarePatch } from '@totem/components/devices/software-patches/types';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { DEVICES_ENDPOINT } from '@totem/utilities/endpoints';

type Props = {
  id: string;
  children?: ReactNode;
};

const SoftwarePatchContainer = ({ id, children }: Props) => {
  const { getApiToken } = useContext(UserProfileContext);
  const [refreshData, setRefreshData] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [data, setData] = useState<SoftwarePatch[]>([]);
  const [action, setAction] = useState<string>('');
  const [actionItem, setActionItem] = useState<SoftwarePatch>(null);

  useEffect(() => {
    if (refreshData) {
      setRefreshData(false);

      setIsLoading(true);

      const uri = `${DEVICES_ENDPOINT}/${id}/software-patches`;

      fetch(uri, {
        method: 'GET',
        headers: new Headers({
          Authorization: `Bearer ${getApiToken()}`,
        }),
      })
        .then((res) => res.json())
        .then((result: SoftwarePatch[]) => {
          setData(result);
        })
        .then(() => {
          setIsLoading(false);
        });
    }
  }, [id, refreshData, getApiToken]);

  const handleAction = (newAction: string, item: SoftwarePatch) => {
    switch (newAction) {
      default:
        setAction(newAction);

        setActionItem(item);
    }
  };

  return (
    <SoftwarePatchContext.Provider
      value={{
        deviceId: id,
        loading: isLoading,
        data,
        action,
        actionItem,
        onAction: handleAction,
      }}
    >
      <div>{children}</div>
    </SoftwarePatchContext.Provider>
  );
};

export default SoftwarePatchContainer;
